import AxiosAPI from '@qualitas/libs';
import { AxiosResponse } from 'axios';

import { SuitabilityTest, SuitabilityTestPT } from '../Models';

export const SuitabilityTestAPI = (baseURL: string | undefined, clientId: string) => {
    const api = AxiosAPI({
        baseURL,
        clientId,
        isApp: true,
        hasUnderMaintenance: false
    });

	const getSuitabilityTest = (idContract: number) => {
        const serviceUrl = `/bookbuilding-api/SuitabilityTest`;
        return api.get(serviceUrl, { params: { idContract } })
            .then((response: AxiosResponse) => response.data)
            .catch((error: any) => error);
    };

    const saveSuitabilityTest = (data: SuitabilityTest) => {
        const serviceUrl = `/bookbuilding-api/SuitabilityTest`;
        return api.post(serviceUrl, data)
            .then((response: AxiosResponse) => response.data)
            .catch((error: any) => error);
    };

    const getSuitabilityTestPT = (idContract: number) => {
        const serviceUrl = `/bookbuilding-api/SuitabilityTest/PT`;
        return api.get(serviceUrl, { params: { idContract } })
            .then((response: AxiosResponse) => response.data)
            .catch((error: any) => error);
    };

    const saveSuitabilityTestPT = (data: SuitabilityTestPT) => {
        const serviceUrl = `/bookbuilding-api/SuitabilityTest/PT`;
        return api.post(serviceUrl, data)
            .then((response: AxiosResponse) => response.data)
            .catch((error: any) => error);
    };

    return {
        getSuitabilityTest,
        saveSuitabilityTest,
        getSuitabilityTestPT,
        saveSuitabilityTestPT
    };
};
